import { createAction, props } from "@ngrx/store";
import { DocumentDto } from "../../models/DocumentDto";
import { ValueConfPagesDto } from "../../models/ValueConfPage";


export enum DocumnentTypes {
    RetrieveDocumentType = '[Documents API] Documents API Success',
    InvokeDocumentApiType = '[Documents API] Invoke API',
}

export const retrieveDocument = createAction(DocumnentTypes.RetrieveDocumentType, props<{ document: DocumentDto }>());
export const invokeDocumentApi = createAction(DocumnentTypes.InvokeDocumentApiType, props<{ id: string, dbname: string }>());


